module.exports = {"id":"211408","name":"Karol Linetty","rating":"76","photo":"./data/images/photos/3/211408.png","club":{"name":"Sampdoria","logo":"./data/images/clubs/Sampdoria.png"},"positions":["MC","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KarolLinetty0.json
// module id = 2296
// module chunks = 0